import React, { useEffect, useRef, useState } from "react";
import { Typography, Table, Row, Modal, Col, Tag, Icon, Button, Tabs, Input, message } from "antd";

import Loader from "components/Loader/Loader";

import {
    fetchPosActivityListApi,
    fetchPosActivityDetailsApi,
    fetchPosMemberListApi,
    createPosMemberApi,
} from "utils/apiService";

import mergeContactsSmall from "media/mergeContactsSmall.svg";
import mergeCardsSmall from "media/mergeCardsSmall.svg";
import updateContactSmall from "media/updateContactSmall.svg";
import phoneGreen from "media/phoneGreen.svg";
import phoneBlack from "media/phoneBlack.svg";
import cardIllustration from "media/inaamCards.svg";
import cardIllustrationBlack from "media/cardIllustrationBlack.svg";
import cardIllustrationGreen from "media/cardIllustrationGreen.svg";
import pointsBlack from "media/pointsBlack.svg";
import pointsGreen from "media/pointsGreen.svg";

const { Text } = Typography;
const { TabPane } = Tabs;

const CardDetails = ({ cardNumber, cardPoints, status }) => {
    return (
        <Row>
            <Col span={12}>
                <Row
                    type='flex'
                    gutter={[12, 12]}
                    align='middle'
                    // style={{
                    // 	paddingRight: 16,
                    // }}
                >
                    <Col>
                        <img
                            src={status === "old" ? cardIllustrationBlack : cardIllustration}
                            style={{ width: "52px", height: "52px", paddingRight: 16 }}
                            alt={"Illustration"}
                        />
                    </Col>
                    <Col>
                        <Text
                            style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: "14px",
                                lineHeight: "22px",
                                color: "#747474",
                            }}>
                            Banat Al Nujoom Card Number
                        </Text>
                        <br />
                        <Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
                            {cardNumber !== undefined && cardNumber !== null ? cardNumber : "-"}
                        </Text>
                    </Col>
                </Row>
            </Col>
            <Col span={12}>
                <Row
                    type='flex'
                    gutter={[12, 12]}
                    align='middle'
                    // style={{
                    // 	paddingRight: 16,
                    // }}
                >
                    <Col>
                        <img
                            src={status === "old" ? pointsBlack : pointsGreen}
                            style={{ width: "52px", height: "52px", paddingRight: 16 }}
                            alt={"Illustration"}
                        />
                    </Col>
                    <Col>
                        <Text
                            style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: "14px",
                                lineHeight: "22px",
                                color: "#747474",
                            }}>
                            Banat Al Nujoom Points
                        </Text>
                        <br />
                        <Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
                            {cardPoints !== undefined && cardPoints !== null ? cardPoints : "-"}
                        </Text>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

const RowDetails = ({ status, phone, cardNumber, cardPoints }) => {
    return (
        <Row>
            <Row type='flex' gutter={[12, 12]} align='middle'>
                <Col>
                    <img
                        src={status === "old" ? phoneBlack : phoneGreen}
                        style={{ width: "52px", height: "52px", paddingRight: 16 }}
                        alt={"Illustration"}
                    />
                </Col>
                <Col>
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#747474",
                        }}>
                        Phone Number
                    </Text>
                    <br />
                    <Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
                        {phone !== undefined && phone !== null ? phone : "-"}
                    </Text>
                </Col>
            </Row>
            <Row type='flex' gutter={[12, 12]} align='middle' style={{ marginTop: 16 }}>
                <Col>
                    <img
                        src={status === "old" ? cardIllustrationBlack : cardIllustrationGreen}
                        style={{ width: "52px", height: "52px", paddingRight: 16 }}
                        alt={"Illustration"}
                    />
                </Col>
                <Col>
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#747474",
                        }}>
                        Banat Al Nujoom Card Number
                    </Text>
                    <br />
                    <Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
                        {cardNumber !== undefined && cardNumber !== null ? cardNumber : "-"}
                    </Text>
                </Col>
            </Row>
            <Row type='flex' gutter={[12, 12]} align='middle' style={{ marginTop: 16 }}>
                <Col>
                    <img
                        src={status === "old" ? pointsBlack : pointsGreen}
                        style={{ width: "52px", height: "52px", paddingRight: 16 }}
                        alt={"Illustration"}
                    />
                </Col>
                <Col>
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#747474",
                        }}>
                        Banat Al Nujoom Points
                    </Text>
                    <br />
                    <Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
                        {cardPoints !== undefined && cardPoints !== null ? cardPoints : "-"}
                    </Text>
                </Col>
            </Row>
        </Row>
    );
};

const PosActivity = ({ ...props }) => {
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(true);
    const [searchKey, setSearchKey] = useState("");
    const [activeTab, setActiveTab] = useState('1');
    const [activityList, setActivityList] = useState({
        activities: [],
        pageSize: 50,
        pageNum: 1,
        totalPages: 1,
    });

    const [posMemberList, setPosMemberList] = useState({
        members: [],
        pageSize: 50,
        pageNum: 1,
        totalPages: 1,
    });

    const [rowDetailModal, setRowDetailModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [createMemberModal, setCreateMemberModal] = useState(false);
    const [memberDetail, setMemberDetail] = useState({
        username: "",
        password: "",
        confirm_password: "",
        store_id: "",
    });

    const loadTable = () => {
        setTableLoading(true);

        fetchPosActivityListApi({
            requestData: {
                page: activityList.pageNum,
                search_key: searchKey,
            },
            resCallback: () => {
                loading && setLoading(false);
                setTableLoading(false);
            },
            res200Callback: (res) => {
                setActivityList({
                    ...activityList,
                    activities: res.data.activity_list,
                    totalPages: res.data.total_pages,
                });
            },
            resErrorCallback: () => {
                // props.history.go(-1);
            },
        });
    };

    const loadPosMembers = () => {
        setTableLoading(true);
        fetchPosMemberListApi({
            requestData: {
                page: posMemberList.pageNum,
                search_key: searchKey,
            },
            resCallback: () => {
                loading && setLoading(false);
                setTableLoading(false);
            },
            res200Callback: (res) => {
                setPosMemberList({ ...posMemberList, members: res.data.member_list, totalPages: res.data.total_pages });
            },
            resErrorCallback: () => {
                // props.history.go(-1);
            },
        });
    };

    useEffect(() => {
        if (activeTab === '2') loadTable();
        else loadPosMembers();
    }, [activityList.pageNum, posMemberList.pageNum, searchKey]);

    useEffect(() => {
        loadTable();
        loadPosMembers();
    },[]);

    const columns = [
        {
            title: "Customer",
            dataIndex: ["name", "contact_number"],
            key: "customerDetail",
            render: (_, row) => (
                <Row type='flex' style={{ flexDirection: "column" }}>
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "16px",
                            lineHeight: "24px",
                            color: "#181818",
                            whiteSpace: "nowrap",
                        }}>
                        {row.name ? row.name : "-"}
                    </Text>
                    {row.contact_number && (
                        <Text style={{ fontStyle: "normal", fontSize: "14px", lineHeight: "24px" }}>
                            {row.contact_number}
                        </Text>
                    )}
                </Row>
            ),
        },
        {
            title: "Current Card No.",
            dataIndex: "card_no",
            key: "cardNumber",
            render: (data) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#181818",
                        whiteSpace: "nowrap",
                    }}>
                    {data || "-"}
                </Text>
            ),
        },
        {
            title: "Action Type",
            dataIndex: "type",
            key: "type",
            render: (type) =>
                type === "Change Phone Number" ? (
                    <Tag color='purple'>{type}</Tag>
                ) : type === "Merge Banat Al Nujoom Cards" ? (
                    <Tag color='cyan'>{"Merge Banat Al Nujoom Cards"}</Tag>
                ) : type === "Link Card" ? (
                    <Tag color='green'>{"Link Card"}</Tag>
                ) : (
                    <Tag color='volcano'>{type}</Tag>
                ),
        },
        {
            title: "Activity On",
            dataIndex: "date_created",
            key: "activityOn",
            render: (data) => <div style={{ whiteSpace: "nowrap" }}>{data}</div>,
        },
    ];

    const posColumns = [
        {
            title: "POS Username",
            dataIndex: "username",
            key: "customerDetail",
            render: (data) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#181818",
                        whiteSpace: "nowrap",
                    }}>
                    {data || "-"}
                </Text>
            ),
        },
        {
            title: "Store ID",
            dataIndex: "store_id",
            key: "storeID",
            render: (data) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#181818",
                        whiteSpace: "nowrap",
                    }}>
                    {data || "-"}
                </Text>
            ),
        },
        {
            title: "Created  On",
            dataIndex: "date_created",
            key: "createdOn",
            render: (data) => <div style={{ whiteSpace: "nowrap" }}>{data}</div>,
        },
    ];

    return (
        <Row
            style={{
                width: "100%",
                padding: "40px 25px 70px",
                margin: "60px auto 20px",
                backgroundColor: "#FAFAFA",
            }}
            gutter={[12, 48]}>
            {loading ? (
                <Row type='flex' align='middle' justify='center' style={{ marginTop: "200px" }}>
                    <Loader />
                </Row>
            ) : (
                <>
                    <Row type='flex' align='middle' justify='space-between'>
                        <Text
                            style={{
                                color: "#181818",
                                /*fontFamily: "Gotham",*/ fontStyle: "normal",
                                fontWeight: "bold",
                                fontSize: "24px",
                                lineHeight: "39px",
                                marginBottom: 16,
                            }}>
                            POS Members / Activities
                        </Text>
                        <div style={{ display: "flex" }}>
                            <Input
                                style={{
                                    marginRight: "8px",
                                    width: "275px",
                                    border: "1px solid rgb(0, 0, 0, 0.25)",
                                    borderRadius: "5px",
                                    alignItems: "left",
                                }}
                                value={searchKey}
                                placeholder={`Search ${activeTab === '1' ? "Member" : "Activity"}`}
                                onChange={(e) => {
                                    setSearchKey(e.target.value);
                                }}
                                prefix={<Icon type='search' />}
                                bordered={"true"}
                            />

                            <Button
                                onClick={() => setCreateMemberModal(true)}
                                style={{
                                    alignItems: "center",
                                    padding: "8px 16px",
                                    color: "#FFFFFF",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                    background: "#fec708",
                                    borderRadius: "5px",
                                    height: "100%",
                                    marginRight: "14px",
                                }}>
                                <Icon
                                    type='plus'
                                    style={{
                                        height: "16px",
                                    }}
                                />
                                Add POS Member
                            </Button>
                        </div>
                        <Modal
                            visible={createMemberModal}
                            destroyOnClose
                            maskClosable={false}
                            onCancel={() =>
                                setCreateMemberModal(!createMemberModal) &&
                                setMemberDetail({
                                    username: "",
                                    password: "",
                                    confirm_password: "",
                                    store_id: "",
                                })
                            }
                            footer={null}>
                            <Row className='modal-row'>
                                <Row>
                                    <Icon
                                        type='user-add'
                                        style={{
                                            color: "#181818",
                                            fontSize: "24px",
                                            marginRight: "16px",
                                        }}
                                    />
                                    <Text
                                        style={{
                                            fontWeight: "bold",
                                            color: "#181818",
                                            fontSize: "24px",
                                        }}>
                                        Create New POS Member
                                    </Text>
                                </Row>
                                <Row style={{ marginTop: "30px" }}>
                                    <Col span={24}>
                                        <div>
                                            <Text
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#181818",
                                                }}>
                                                Store ID
                                            </Text>
                                            <Input
                                                style={{
                                                    marginTop: "5px",
                                                    width: "100%",
                                                    border: "1px solid rgb(0, 0, 0, 0.25)",
                                                    borderRadius: "5px",
                                                    alignItems: "left",
                                                }}
                                                value={memberDetail.store_id}
                                                placeholder='Enter the store ID'
                                                onChange={(e) => {
                                                    setMemberDetail({ ...memberDetail, store_id: e.target.value });
                                                }}
                                                bordered={"true"}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "30px" }}>
                                    <Col span={24}>
                                        <div>
                                            <Text
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#181818",
                                                }}>
                                                Username
                                            </Text>
                                            <Input
                                                style={{
                                                    marginTop: "5px",
                                                    width: "100%",
                                                    border: "1px solid rgb(0, 0, 0, 0.25)",
                                                    borderRadius: "5px",
                                                    alignItems: "left",
                                                }}
                                                value={memberDetail.username}
                                                placeholder='Enter a username'
                                                onChange={(e) => {
                                                    setMemberDetail({ ...memberDetail, username: e.target.value });
                                                }}
                                                bordered={true}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "30px" }}>
                                    <Col span={24}>
                                        <div>
                                            <Text
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#181818",
                                                }}>
                                                Password
                                            </Text>
                                            <Input
                                                style={{
                                                    marginTop: "5px",
                                                    width: "100%",
                                                    border: "1px solid rgb(0, 0, 0, 0.25)",
                                                    borderRadius: "5px",
                                                    alignItems: "left",
                                                }}
                                                value={memberDetail.password}
                                                placeholder='Enter a password'
                                                onChange={(e) => {
                                                    setMemberDetail({ ...memberDetail, password: e.target.value });
                                                }}
                                                bordered={true}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "30px" }}>
                                    <Col span={24}>
                                        <div>
                                            <Text
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#181818",
                                                }}>
                                                Confirm Password
                                            </Text>
                                            <Input
                                                style={{
                                                    marginTop: "5px",
                                                    width: "100%",
                                                    border: "1px solid rgb(0, 0, 0, 0.25)",
                                                    borderRadius: "5px",
                                                    alignItems: "left",
                                                }}
                                                value={memberDetail.confirm_password}
                                                placeholder='Enter the password again'
                                                onChange={(e) => {
                                                    setMemberDetail({
                                                        ...memberDetail,
                                                        confirm_password: e.target.value,
                                                    });
                                                }}
                                                bordered={true}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: "30px" }}>
                                    <Col span={24} style={{ textAlign: "right" }}>
                                        <Button
                                            disabled={
                                                !memberDetail.store_id ||
                                                !memberDetail.username ||
                                                !memberDetail.password ||
                                                !memberDetail.confirm_password ||
                                                memberDetail.password !== memberDetail.confirm_password
                                            }
                                            onClick={() => {
                                                createPosMemberApi({
                                                    requestData: { ...memberDetail },
                                                    res200Callback: () => {
                                                        message.success("Member Created Successfully");
                                                        setMemberDetail({
                                                            username: "",
                                                            password: "",
                                                            confirm_password: "",
                                                            store_id: "",
                                                        });
                                                        setCreateMemberModal(false);
                                                        loadPosMembers();
                                                    },
                                                    resErrorCallback: () => {
                                                        message.error("Failed while creating the pos member!");
                                                    },
                                                });
                                            }}
                                            size={"large"}
                                            style={{
                                                backgroundColor: "#fec708",
                                                color: "#FFFFFF",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}>
                                            Create Member
                                        </Button>
                                    </Col>
                                </Row>
                            </Row>
                        </Modal>
                    </Row>
                    <Tabs
                        defaultActiveKey='1'
                        onChange={(key) => {
                            setActiveTab(key);
                            if (key === '2') loadTable();
                            else loadPosMembers();
                        }}>
                        <TabPane tab={"Members"} key='1'>
                            <Table
                                columns={posColumns}
                                dataSource={posMemberList.members}
                                pagination={{
                                    showQuickJumper: true,
                                    current: posMemberList.pageNum,
                                    pageSize: posMemberList.pageSize,
                                    total: posMemberList.pageSize * posMemberList.totalPages,
                                }}
                                style={{ overflow: "none" }}
                                onChange={(pagination) => {
                                    setPosMemberList({ ...posMemberList, pageNum: pagination.current });
                                    // loadPosMembers();
                                }}
                                loading={tableLoading}
                            />
                        </TabPane>
                        <TabPane tab={"Activities"} key='2'>
                            <Table
                                columns={columns}
                                dataSource={activityList.activities}
                                pagination={{
                                    showQuickJumper: true,
                                    current: activityList.pageNum,
                                    pageSize: activityList.pageSize,
                                    total: activityList.pageSize * activityList.totalPages,
                                }}
                                style={{ overflow: "none" }}
                                onChange={(pagination) => {
                                    setActivityList({ ...activityList, pageNum: pagination.current });
                                    // loadTable();
                                }}
                                onRow={(obj) => ({
                                    onClick: () => {
                                        fetchPosActivityDetailsApi({
                                            requestData: {
                                                uuid: obj.uuid,
                                            },
                                            res200Callback: (res) => {
                                                setSelectedRow({ ...res.data });
                                            },
                                        });
                                        setRowDetailModal(true);
                                    },
                                })}
                                loading={tableLoading}
                            />
                            <Modal
                                centered
                                visible={rowDetailModal}
                                destroyOnClose
                                maskClosable={false}
                                onCancel={() => setRowDetailModal(false)}
                                footer={null}
                                style={{ minWidth: "50vw" }}>
                                <Row className='modal-row'>
                                    <Row>
                                        <img
                                            src={
                                                selectedRow?.type === "merge"
                                                    ? mergeCardsSmall
                                                    : selectedRow?.type === "change"
                                                    ? updateContactSmall
                                                    : mergeContactsSmall
                                            }
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                marginRight: 16,
                                            }}
                                            alt={"Illustration"}
                                        />
                                        <Text
                                            style={{
                                                fontWeight: "bold",
                                                color: "#181818",
                                                fontSize: "24px",
                                            }}>
                                            {selectedRow?.type}
                                        </Text>
                                    </Row>
                                    <Row
                                        style={{
                                            // display: "grid",
                                            // gridTemplateColumns: "1fr 1fr",
                                            marginTop: "24px",
                                            // gap: 100,
                                        }}>
                                        <Col span={12}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flexGrow: 1,
                                                    paddingRight: 28,
                                                }}>
                                                <Text
                                                    style={{
                                                        fontSize: "20px",
                                                        color: "#181818",
                                                        fontWeight: "bold",
                                                        lineHeight: "32px",
                                                        marginBottom: "24px",
                                                    }}>
                                                    {/* <Text style={{ border: "1px solid #181818", borderRadius: "50px", fontSize: "14px", lineHeight: "14px" }}>1</Text>{" "} */}
                                                    1 Old Details
                                                </Text>
                                                {selectedRow &&
                                                    (selectedRow?.type === "Merge Banat Al Nujoom Cards" ? (
                                                        <>
                                                            <div>
                                                                {selectedRow?.old_reward_card.map((card) => (
                                                                    <CardDetails
                                                                        cardNumber={card.card_no}
                                                                        cardPoints={card.points}
                                                                        status='old'
                                                                    />
                                                                ))}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RowDetails
                                                                cardNumber={selectedRow?.old_reward_card[0].card_no}
                                                                cardPoints={selectedRow?.old_reward_card[0].points}
                                                                phone={selectedRow?.old_contact_number}
                                                                status='old'
                                                            />
                                                        </>
                                                    ))}
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flexGrow: 1,
                                                    paddingRight: 28,
                                                }}>
                                                <Text
                                                    style={{
                                                        fontSize: "20px",
                                                        color: "#181818",
                                                        fontWeight: "bold",
                                                        lineHeight: "32px",
                                                        marginBottom: "24px",
                                                    }}>
                                                    {/* <Text style={{ border: "1px solid #181818", borderRadius: "50px", fontSize: "14px", lineHeight: "14px" }}>2</Text>{" "} */}
                                                    2 New Details
                                                </Text>
                                                {selectedRow &&
                                                    (selectedRow?.type === "Merge Banat Al Nujoom Cards" ? (
                                                        <>
                                                            <div>
                                                                <CardDetails
                                                                    cardNumber={selectedRow?.new_reward_card[0].card_no}
                                                                    cardPoints={selectedRow?.new_reward_card[0].points}
                                                                    status='new'
                                                                />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RowDetails
                                                                cardNumber={selectedRow?.new_reward_card[0].card_no}
                                                                cardPoints={selectedRow?.new_reward_card[0].points}
                                                                phone={selectedRow?.new_contact_number}
                                                                status='new'
                                                            />
                                                        </>
                                                    ))}
                                            </div>
                                        </Col>
                                    </Row>
                                </Row>
                            </Modal>
                        </TabPane>
                    </Tabs>
                </>
            )}
        </Row>
    );
};

export default PosActivity;
